import React from 'react';
import { EntityLayout } from '@backstage/plugin-catalog';
import { Grid } from '@material-ui/core';
import { WarningCard } from '../../cards/WarningCard';
import {
  EntityGroupProfileCard,
  EntityMembersListCard,
} from '@backstage/plugin-org';

export const AdGroupPage = () => (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        <WarningCard />
        <Grid item xs={12}>
          <EntityGroupProfileCard />
        </Grid>
        <Grid item xs={12}>
          <EntityMembersListCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>
  </EntityLayout>
);
